/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {useIntl} from 'react-intl'
import {validateEmail} from '../../utils/form-utils'

export default function useLoginFields({
    form: {
        control,
        formState: {errors}
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()
    const backgroundColor = 'white'
    const fields = {
        email: {
            name: `${prefix}email`,
            label: formatMessage({defaultMessage: 'Email', id: 'use_login_fields.label.email'}),
            placeholder: 'you@email.com',
            defaultValue: '',
            type: 'email',
            autoComplete: 'email',
            rules: {
                validate: (value) => {
                    return (
                        validateEmail(value) ||
                        formatMessage({
                            defaultMessage:
                                "Please enter a valid email address. An email address must contain the '@' symbol and a valid domain name (such as .com, .org, or .edu).",
                            id: 'use_address_fields.error.invalid_email'
                        })
                    )
                },
                required: formatMessage({
                    defaultMessage: 'Please enter your email address.',
                    id: 'use_login_fields.error.required_email'
                })
            },
            error: errors?.[`${prefix}email`],
            control,
            backgroundColor
        },
        password: {
            name: `${prefix}password`,
            label: formatMessage({
                defaultMessage: 'Password',
                id: 'use_login_fields.label.password'
            }),
            defaultValue: '',
            type: 'password',
            rules: {
                validate: (value) => {
                    return (
                        (value && value.length >= 8) ||
                        formatMessage({
                            defaultMessage: 'Please enter at least 8 characters.',
                            id: 'use_address_fields.error.password_length'
                        })
                    )
                },
                required: formatMessage({
                    defaultMessage: 'Please enter your password.',
                    id: 'use_login_fields.error.required_password'
                })
            },
            error: errors?.[`${prefix}password`],
            control,
            backgroundColor
        }
    }
    return fields
}
